var _path, _path2, _path3, _path4, _path5, _circle, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZubehoerinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.681 0h39v39h-39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.466 19.004c.529.046.862.194.507.712-.397.578-1.467 1.038-1.686.136-.05-.202-.153-.864.303-1.125.516-.295.549.248.876.277z",
    fill: "url(#zubehoer_inline_svg__zubehoer_inline_svg___Linear1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.46 19.159a.534.534 0 00-.533-.534h-3.358a.535.535 0 00-.534.534v1.068c0 .294.239.533.534.533h3.358a.533.533 0 00.533-.533v-1.068z",
    fill: "#fff",
    stroke: "#364148",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.92 8.082a.84.84 0 00-.839.839v21.844a.84.84 0 00.839.839h1.678a.84.84 0 00.839-.839V8.921a.84.84 0 00-.839-.839H12.92zm-.839 10.761v2h-1.019c-.605 0-.652-.224-.652-.5v-.999c0-.277.047-.501.652-.501h1.019zm3.356 0h14.305c.605 0 .668.224.668.501v.999c0 .276-.063.5-.668.5H15.437v-2z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.511 8.088a.84.84 0 00-.839.839v21.844a.84.84 0 00.839.839h1.678a.84.84 0 00.839-.839V8.927a.84.84 0 00-.839-.839h-1.678z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.383,
    cy: 19.378,
    r: 3.75,
    fill: "#009ee0",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinecap: "butt",
    strokeMiterlimit: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.239 19.553a.256.256 0 01-.256.256h-1.361v1.308a.274.274 0 01-.274.274h-.001a.274.274 0 01-.274-.274v-1.308h-1.361a.256.256 0 01-.256-.256v-.002c0-.141.115-.256.256-.256h1.361v-1.318c0-.151.123-.274.274-.274h.001c.151 0 .274.123.274.274v1.318h1.361c.141 0 .256.115.256.256v.002z",
    fill: "#fff",
    fillRule: "nonzero"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "zubehoer_inline_svg__zubehoer_inline_svg___Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-92 19.932 .415) scale(1.72096)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005791",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ddf",
    stopOpacity: 1
  })))));
}

export default SvgZubehoerinline;